import React, { FC, useEffect } from 'react';
import List from '@mui/material/List';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { useUnit } from 'effector-react';
import { MenuItem } from './MenuItem';
import { $open } from './model';
import { addressesGRID } from '../../GRID/addresses';
import { $dynamicObjectExportAccess } from '../../GRID/pages/dynamicObjectExport/accessModel';


export const MainMenu: FC = () => {
  const open = useUnit($open);
  const dynamicObjectExportAccess = useUnit($dynamicObjectExportAccess);



  return (
    <List>
      <MenuItem
        open={open}
        text="Доски"
        Icon={<ViewKanbanIcon color="primary" />}
        to={addressesGRID.desksPath}
      />
      {dynamicObjectExportAccess && (
        <MenuItem
          open={open}
          text="Отчет по обороту и выручке"
          Icon={<AssessmentIcon color="primary" />}
          to="/dynamic-object-export"
        />
      )}
    </List>
  );
};
